// Shared by every section on the profile page, copied from register.tsx so
// the three sections don't each carry their own copy.
interface ErrorBody {
  error?: string;
  message?: string;
}

export function getStatus(e: unknown): number | undefined {
  return (e as { status?: number } | null)?.status;
}

export function getBody(e: unknown): ErrorBody | undefined {
  if (e && typeof e === 'object') {
    const maybe = e as { body?: ErrorBody; detail?: ErrorBody } & ErrorBody;
    return maybe.body ?? maybe.detail ?? maybe;
  }
  return undefined;
}
